module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/twitter-icon-61b121ab8ed1f3b5eb276fe989fa085e.png";